/**
 * Shop Entry Point
 *
 * Mounts the ProductGrid component on the shop page.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ShopProvider } from '@/context';
import { ProductGrid } from '@/components/Shop/ProductGrid';

// Find all shop containers (there can be multiple via shortcodes)
const containers = document.querySelectorAll('.evcs-shop, .evcs-products-grid');

containers.forEach((container) => {
  if (container instanceof HTMLElement) {
    // Read configuration from data attributes
    const config = {
      columns: parseInt(container.dataset.columns || '3', 10),
      perPage: parseInt(container.dataset.perPage || '12', 10),
      category: container.dataset.category || '',
      orderby: container.dataset.orderby || 'date',
      order: container.dataset.order || 'DESC',
      ids: container.dataset.ids || '',
      onSale: container.dataset.onSale === 'true',
      showFilters: container.dataset.showFilters !== 'false',
    };

    const root = createRoot(container);
    root.render(
      <StrictMode>
        <ShopProvider>
          <ProductGrid {...config} />
        </ShopProvider>
      </StrictMode>
    );
  }
});
